module.exports = __webpack_public_path__ + "static/fonts/D-DINExp-Bold.fa367cc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ttf/D-DINExp-Bold.ttf
// module id = 523
// module chunks = 2 3 5 6